module.exports = __webpack_public_path__ + "img/tree-1.d4ce783d.jpg";